import React, { useEffect, useState } from "react";
import { useNavigate, useLocation  } from "react-router";
import { useStoreLocation } from "../../../context/StoreLocation";
import * as CONSTANT from "../../../../src/constants";
import Scrollbars from "react-custom-scrollbars-2";
import styleClasses from "./ItemDetailMenuCategory.module.scss";
import { Container } from "react-bootstrap";
import useCategories from "../../../react-query-hooks/useCategories";
import { useAuthState } from "../../../context/UserAuthentication";
import useTrackBarVisibility from "../../../hooks/useTrackBarVisibility";

const ItemDetailMenuCategory = ({category_id}) => {

  const [showScrollBar, setShowScrollBar] = useState<boolean>(true);
  const [stickyClass, setStickyClass] = React.useState("remove-sticky");
  const [category, setCategory] = useState([]);
  const { locationInfo } = useStoreLocation();
  const { authInfo } = useAuthState();
  const location_id = locationInfo.selectedStore?.id;
  const { data: menus = [] } = useCategories(location_id, authInfo);
  const history: any = useNavigate();
  const location = useLocation();

  const id = location?.state?.category_id ?? category_id;

  const MenuLinksHandler = (menu) => {
    history(`${CONSTANT.ROUTE_MENU}/${menu.name}`, {
      replace: true,
      state: { showCustomization: false },
    });
  };



  const handleScroll = () => {
    window.scrollY > 1
      ? setStickyClass(`${styleClasses.add_sticky}`)
      : setStickyClass("remove-sticky");
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const categoryFromRoute = location?.state?.categoryMenu;
    categoryFromRoute ? setCategory(categoryFromRoute) : setCategory(menus);
  }, [menus.length]);

  
  const isCheckTrackBar = useTrackBarVisibility();
  return (
    <div
      className={`item-detail-menu-wrapper ${isCheckTrackBar
        ? "order-track-bar"
        : "no-order-track"} ${showScrollBar && stickyClass}  ${
        styleClasses.item_detail_menu_wrapper
      }  ${
        isCheckTrackBar
          ? styleClasses.order_track_bar
          : styleClasses.no_order_track
      }`}
    >
      <Container fluid>
        <h1 className="menu_cate_title h-18 text-start mb-0 pt-1 px-lg-4 px-2">
          Menu Categories
        </h1>
        <Scrollbars
          className={`${styleClasses.item_detail_menu_scrollbar} menu_tabs_wrap  blue`}
          renderThumbHorizontal={(props) => (
            <div {...props} className={styleClasses.Scrollbar_thumb} />
          )}
          renderView={(props) => (
            <div
              {...props}
              className={`${styleClasses.Scrollbar_view} Scrollbar_view`}
            />
          )}
        >
          {category.map((menu, i: number) => (
            <div
              id={menu.name}
              key={i}
              className={styleClasses.item_detail_menu_tabs}
            >
              <a
                onClick={() => MenuLinksHandler(menu)}
                className={`${styleClasses.item_detail_nav_item} ${
                  id == menu.id
                    ? `${styleClasses.active}`
                    : ""
                }`}
              >
                {menu.name}
              </a>
            </div>
          ))}
        </Scrollbars>
      </Container>
    </div>
  );
};

export default ItemDetailMenuCategory;
